import { createHttpClient, getErrorMapper } from '@systemeio/util'
import { rollbar } from 'rollbar/instance'

export const httpClient = createHttpClient()

httpClient.interceptors.response.use(response => response, getErrorMapper(httpClient, rollbar))

httpClient.interceptors.response.use(response => {
  if (response.status === 202 && response.config?.method === 'get') {
    rollbar.info('Unexpected 202 response', response)
  }
  return response
})
